import { useTranslation } from "react-i18next";
import { MessageSquare, Zap, Cpu } from "lucide-react";
import DemoCTA from "./DemoCTA";
import { useSectionView } from "@/hooks/use-section-view";

const SolutionSection = () => {
  const sectionRef = useSectionView<HTMLElement>("solution");
  const { t } = useTranslation();

  const solutions = [
    {
      icon: MessageSquare,
      titleKey: "solution.hub.title",
      descKey: "solution.hub.description",
    },
    {
      icon: Zap,
      titleKey: "solution.automation.title",
      descKey: "solution.automation.description",
    },
    {
      icon: Cpu,
      titleKey: "solution.via.title",
      descKey: "solution.via.description",
      highlight: true,
    },
  ];

  return (
    <section ref={sectionRef} id="solucao" className="py-20 lg:py-32 bg-background scroll-mt-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            {t("solution.title")} <span className="text-primary">{t("solution.titleHighlight")}</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            {t("solution.subtitle")}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          {solutions.map((solution, index) => {
            const Icon = solution.icon;
            return (
              <div
                key={index}
                className={`group flex flex-col overflow-hidden rounded-2xl border transition-all duration-300 animate-scale-in ${solution.highlight
                  ? "bg-gradient-to-br from-primary/10 to-primary/5 border-primary hover:shadow-lg hover:border-primary"
                  : "bg-card border-border hover:shadow-card hover:border-primary/20"
                  }`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="p-8 flex-1">
                  <div className={`w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 ${solution.highlight ? "bg-primary" : "bg-accent"
                    }`}>
                    <Icon className={`w-8 h-8 ${solution.highlight ? "text-primary-foreground" : "text-primary"}`} />
                  </div>
                  <h3 className="text-2xl font-semibold mb-4">{t(solution.titleKey)}</h3>
                  <p className="text-muted-foreground leading-relaxed text-base">
                    {t(solution.descKey)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="animate-fade-in">
          <DemoCTA location="solution" />
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
